/**
 * HomeSLOrbHomeRoute
 *
 * Page component for HomeSLOrbHomeRoute
 * Path: /sl
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { HomeSLOrbHomePageView as __HomeSLOrbHomePageView } from '@/components/traits/HomeSLOrbHomePageView';
import { HomeSLOrbHomeAnalyticsView as __HomeSLOrbHomeAnalyticsView } from '@/components/traits/HomeSLOrbHomeAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';

interface HomeSLOrbHomeRouteProps {
  // Add any page-level props here
}

export function HomeSLOrbHomeRoute(_props: HomeSLOrbHomeRouteProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-orb-home:meta.title"],"description":["i18n/t","std-orb-home:meta.description"],"access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/"},{"locale":"ar","path":"/ar"},{"locale":"sl","path":"/sl"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__HomeSLOrbHomePageView config={{ initPayload: __navState }} />
          <__HomeSLOrbHomeAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default HomeSLOrbHomeRoute;
